module.exports = __webpack_public_path__ + "img/baas_42.5081ebe0.png";